export default "__VITE_ASSET__BFCwhWOM__"